import * as React from 'react'
import { ReactElement } from 'react'
import TimeForm from '../../components/Form/Time/TimeForm'
import EditEntityForm from '../../components/Form/EditEntityForm'
import { TimeMutationDto, TimeOverviewDto } from '../../config/registrationConfig'
import { EntityFormPage } from '../../components/Form/Form'
import { InvoiceStatus } from '../../config/finance/invoiceConfig'
import { TimeAction } from '../../config/registration/timeConfig'
import useAxios from '../../hooks/useAxios'

export default function EditTime(props: EntityFormPage): ReactElement {
    const axios = useAxios()
    return (
        <EditEntityForm<TimeOverviewDto, TimeMutationDto>
            {...props}
            form={TimeForm}
            getEntity={(id: string) => ({ url: `/time/${id}`, method: 'GET' })}
            getLockedDelete={(entity: TimeOverviewDto) => !!entity.invoice?.status}
            getLockedSave={(entity: TimeOverviewDto) => [InvoiceStatus.Final, InvoiceStatus.Done].includes(entity.invoice?.status)}
            updateEntity={(id, values) => ({
                type: TimeAction.Update,
                payload: axios.put(`/time/${id}`, values),
            })}
            deleteEntity={id => ({
                type: TimeAction.Delete,
                payload: axios.delete(`/time/${id}`),
            })}
        />
    )
}
